import { Component, Input, OnInit } from "@angular/core";
import { Observable } from "rxjs";

@Component({
    selector: 'eic-asset-contractors',
    template: `

    <div *ngIf="assetContractors$ | async as assetContractors">
        <h3>Contractors</h3>
<table class="projectSectionTable">
  <tr>
    <th>Contract Type</th>
    <th>Company Name</th>
    <th>Company Address</th>
    <th>Contact Name</th>
    <th>Contact Job Title</th>
    <th>Contact Number</th>
    <th>Contact Email</th>
    <th>Contract Term End Date</th>
    <th>Is Framework Contract</th>
  </tr>
  <tr *ngFor="let contract of assetContractors">
    <td>{{ contract.contractType }}</td>
    <td>{{ contract.companyName }}</td>
    <td>{{ contract.companyAddress }}</td>
    <td>{{ contract.contactName }}</td>
    <td>{{ contract.contactJobTitle }}</td>
    <td>{{ contract.contactNumber }}</td>
    <td>{{ contract.contactEmail }}</td>
    <td>{{ contract.contractTermEndDate | date }}</td>
    <td>{{ contract.isFrameworkContract ? 'Yes' : 'No' }}</td>
  </tr>
</table>
    </div>
    `,
    //styleUrls: ['./equipment.styles.scss']
})
export class AssetContractors implements OnInit {
    @Input() assetContractors$: Observable<any[]>;

    constructor() {

    }
  
    ngOnInit(): void {

    }

}